import { Flex, IconCreditCard, Text, csx } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { InstallmentsConfig } from '.'
import { Tag } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  config: InstallmentsConfig | undefined
  onEdit: () => void
  onRemove: () => void
}

enum Criteria {
  FLOOR = 'floor',
  CEIL = 'ceil',
  RANGE = 'range',
}

export function getInstallmentsCriteria(
  config: NonNullable<InstallmentsConfig>
) {
  const { min, max } = config

  if (min && !max) return Criteria.FLOOR
  if (!min && max) return Criteria.CEIL
  return Criteria.RANGE
}

export function InstallmentsView(props: Props) {
  const { $t } = useIntl()

  const { config, onEdit, onRemove } = props

  if (!config) return null

  const { min, max } = config

  const criteria = getInstallmentsCriteria(config)

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconCreditCard />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          criteria,
        })}
      </RuleDescription>

      <RuleContent>
        {criteria === Criteria.FLOOR && (
          <Tag>{$t(messages.view.times, { value: min })}</Tag>
        )}

        {criteria === Criteria.CEIL && (
          <Tag>{$t(messages.view.times, { value: max })}</Tag>
        )}

        {criteria === Criteria.RANGE && (
          <Flex align="center" className={csx({ columnGap: '$space-2' })}>
            {$t(messages.view.interval, {
              minValue: <Tag>{$t(messages.view.times, { value: min })}</Tag>,
              maxValue: <Tag>{$t(messages.view.times, { value: max })}</Tag>,
            })}
          </Flex>
        )}
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
